import * as React from "react";
import Icon from "../icon";
import Input from "../input";
import Trigger from "rc-trigger";
const { TextArea } = Input;
//分隔符
const SPLIT_REG = /[,\r\n，]/;
export default class MultipleInput extends React.Component {
    constructor(props) {
        super(props);
        this.handleValueData = (code, valueData) => {
            let newCode = code.split(SPLIT_REG);
            let newArray = valueData.concat(newCode);
            let step = new Map();
            let data = newArray.filter((res) => res && !step.has(res) && step.set(res, 1)); //数组去重,
            return data;
        };
        this.onChange = (e) => {
            let code = e.target.value || "";
            let { valueData } = this.state;
            //直接在表格中删除
            if (!code && !SPLIT_REG.test(code)) {
                this.setState({ value: "", valueData: [] }, () => {
                    this.props.onChange && this.props.onChange("");
                });
                return;
            }
            //单个输入
            if (SPLIT_REG.test(code)) {
                let data = this.handleValueData(code, valueData);
                this.setState({
                    dropDown: true,
                    valueData: data,
                    value: "",
                });
            }
            else {
                this.setState({ value: code });
            }
        };
        this.handleDelete = (item) => {
            let valueData = this.state.valueData;
            let data = valueData.filter((filter) => filter !== item) || [];
            this.setState({
                valueData: data
            });
        };
        this.handleDeleteAll = () => {
            this.setState({ value: "", valueData: [] }, () => {
                this.props.onChange && this.props.onChange("");
            });
        };
        this.renderOptions = (item) => {
            return (<div className="drop-drown-option">
        <Input disabled className="dropdown-option-input" value={item}/>
        <Icon className="dropdown-option-delete" type="plus-circle" onClick={this.handleDelete.bind(this, item)}/>
      </div>);
        };
        this.onPopupVisibleChange = (show) => {
            if (show) {
                this.setState({
                    dropDown: show,
                    value: ''
                });
            }
            else {
                const { valueData, value } = this.state;
                let data = valueData;
                if (value) {
                    valueData.push(value);
                    let step = new Map();
                    data = valueData.filter((res) => !step.has(res) && step.set(res, 1)); //数组去重,
                }
                this.setState({
                    dropDown: false,
                    value: data.join(","),
                    valueData: data,
                });
                this.props.onChange && this.props.onChange(data.join(","));
            }
        };
        this.onMouseOut = () => {
            const { value, valueData, dropDown } = this.state;
            if ((!dropDown) && value && (!valueData.length) && (!SPLIT_REG.test(value))) {
                this.props.onChange && this.props.onChange(value);
            }
        };
        this.state = {
            value: props.value ? props.value : "",
            dropDown: props.dropDown ? props.dropDown : false,
            valueData: props.valueData ? props.valueData : [],
        };
    }
    //如果props.value存在 要處理valueData
    componentDidMount() {
        if (this.props.value) {
            let data = this.handleValueData(this.props.value, []);
            this.setState({ valueData: data });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            if (!nextProps.value) {
                this.setState({
                    value: "",
                    valueData: [],
                });
            }
            else {
                let data = this.handleValueData(nextProps.value, []);
                this.setState({
                    value: nextProps.value,
                    valueData: data,
                });
            }
        }
    }
    showDropDown() {
        let { valueData, dropDown } = this.state;
        if (dropDown && !!valueData.length) {
            return (<div className="drop-drown-style">
          {valueData.map((item) => {
                return this.renderOptions(item);
            })}
        </div>);
        }
        else {
            return <div />;
        }
    }
    render() {
        let { value, dropDown } = this.state;
        return (<div className="select-input" ref="node">
        <Trigger className="input-multiple-wrap" action={["click"]} popup={this.showDropDown()} popupAlign={{
            points: ["tl", "bl"],
            offset: [0, 10],
        }} onPopupVisibleChange={this.onPopupVisibleChange} popupVisible={dropDown} getPopupContainer={(target) => target.parentNode}>
          <div>
            <TextArea {...this.props} value={value} onChange={this.onChange.bind(this)} autosize={{ maxRows: 1 }} title={value} onBlur={this.onMouseOut}/>
            <Icon className="input-multiple-delete" type="cross-circle" onClick={this.handleDeleteAll}/>
          </div>
        </Trigger>
      </div>);
    }
}



// WEBPACK FOOTER //
// ./components/multipleinput/index.tsx